import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './infographic-item.scss.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';

class InfographicItem extends s {
    render() {
        return $ `<div class="item ${this.colorschema} ${this.rtl || isRTL() ? 'rtl' : ''}"><div class="circle-area"><div class="body"><slot name="main-text"></slot><slot name="post-text"></slot></div></div><slot name="description"></slot></div>`;
    }
}
InfographicItem.styles = css_248z;
__decorate([
    e({ type: Boolean })
], InfographicItem.prototype, "rtl", void 0);
__decorate([
    e({ type: String })
], InfographicItem.prototype, "colorschema", void 0);
customElements.define('infographic-item', InfographicItem);

export { InfographicItem };
